import { DEFAULT_PACKAGE_ICON } from "ee/constants/PackageConstants";
import { Icon, Text } from "@appsmith/ads";
import React from "react";
import history from "utils/history";
import { SearchListItem } from "pages/common/SearchBar/WorkspaceSearchItems";
import { workflowEditorURL } from "ee/RouteBuilder";
import type { Workflow } from "ee/constants/WorkflowConstants";

interface Props {
  workflowsList: Workflow[];
}

const WorkflowSearchItem = (props: Props) => {
  const { workflowsList } = props;
  if (!workflowsList || workflowsList?.length === 0) return null;
  return (
    <div>
      <Text className="!mb-2 !block" kind="body-s">
        Workflows
      </Text>
      {/* TODO: Fix this the next time the file is edited */}
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      {workflowsList.map((workflow: any) => (
        <SearchListItem
          key={workflow.id}
          onClick={() =>
            history.push(workflowEditorURL({ workflowId: workflow.id }))
          }
        >
          <Icon
            className="!mr-2"
            color="var(--ads-v2-color-fg)"
            name={workflow.icon || DEFAULT_PACKAGE_ICON}
            size="md"
          />
          <Text className="truncate" kind="body-m">
            {workflow.name}
          </Text>
        </SearchListItem>
      ))}
    </div>
  );
};

export default WorkflowSearchItem;
